import React, { FC } from "react";
import ResellerRouter from "./ResellerRouter";
import Router from "./Router";
import { useTranslation } from "react-i18next";

interface IRouterOrchestratorProps {
    darkMode: boolean;
    setDarkMode: (value: boolean) => void;
    refresh: () => void;
}


const RouterOrchestrator: FC<IRouterOrchestratorProps> = ({ darkMode, setDarkMode, refresh }) => {
  const { i18n } = useTranslation();

  if (process.env.REACT_APP_IS_RESELLER === "true") {
    return <ResellerRouter language={i18n.language} />;
  }

  return <Router language={i18n.language} darkMode={darkMode} setDarkMode={setDarkMode} refresh={refresh} />;
}

export default RouterOrchestrator;
